import { AccredibleButtonComponentModule } from '@accredible-frontend-v2/new-components/button';
import { AccredibleIconComponentModule } from '@accredible-frontend-v2/new-components/icon';
import { AccredibleLanguageService } from '@accredible-frontend-v2/services/language';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

const TRANSLATION_KEY = 'inline-confirmation';

@Component({
  standalone: true,
  selector: 'accredible-inline-confirmation',
  imports: [
    CommonModule,
    AccredibleIconComponentModule,
    AccredibleButtonComponentModule,
    TranslocoModule,
  ],
  templateUrl: 'inline-confirmation.component.html',
  styleUrls: ['inline-confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InlineConfirmationComponent {
  private readonly _language = inject(AccredibleLanguageService);

  confirmationText = input.required<string>();
  dataCy = input<string | number>();
  confirmButtonText = input(this._language.translate(`${TRANSLATION_KEY}.delete`));
  cancelButtonText = input(this._language.translate(`${TRANSLATION_KEY}.keep`));

  confirm = output<Event>();
  cancel = output<Event>();

  confirmDataCy = computed(
    () => 'btn-inline-confirm' + (this.dataCy() || this.dataCy() === 0 ? `-${this.dataCy()}` : ''),
  );
  cancelDataCy = computed(
    () => 'btn-inline-cancel' + (this.dataCy() || this.dataCy() === 0 ? `-${this.dataCy()}` : ''),
  );
}
